module.exports = __webpack_public_path__ + "0e63ab06fcbc28af7d6bc06e72a289c4.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/misc/note-sm.png
// module id = 1050
// module chunks = 0